import { getOuterWidth, getOuterHeight } from "@/js/helpers/getElementDimension";

const SELECTOR = "js-background-video";
const IS_PORTRAIT_CLASSNAME = "is-portrait";

class BackgroundVideo {
    static attach(container) {
        const backgroundVideoElements = container.querySelectorAll(SELECTOR);
        if (backgroundVideoElements) {
            [...backgroundVideoElements].forEach((backgroundVideoElement) => {
                /* eslint-disable-next-line no-unused-vars */
                const backgroundVideo = new BackgroundVideo(backgroundVideoElement);
            });
        }
    }

    constructor(wrapper) {
        this.wrapperElement =
            typeof wrapper === "string" ? document.querySelector(wrapper) : wrapper;

        if (this.wrapperElement) {
            this.videoElement = this.wrapperElement.querySelector("video");
        }

        this.isPortrait = false;
        this.attachVideoEvents();
        this.toggleIsPortrait();
        this.render();
    }

    attachVideoEvents() {
        if (this.videoElement) {
            this.videoElement.on("loadedmetadata", () => {
                this.toggleIsPortrait();
            });
        }

        [...this.wrapperElement.querySelectorAll("img")].forEach((imageElement) => {
            imageElement.on("load", () => {
                this.toggleIsPortrait();
            });
        });
    }

    toggleIsPortrait() {
        const widthRatio = getOuterWidth(this.wrapperElement) / this.video.videoWidth;
        const heightRatio = getOuterHeight(this.wrapperElement) / this.video.videoHeight;
        this.isPortrait = widthRatio < heightRatio;

        this.render();
    }

    render() {
        if (this.isPortrait) {
            this.wrapperElement.classList.add(IS_PORTRAIT_CLASSNAME);
        } else {
            this.wrapperElement.classList.remove(IS_PORTRAIT_CLASSNAME);
        }
    }
}

export { BackgroundVideo };
